// src/components/IconPickerSelect.tsx

import React, { JSX } from 'react';
import Select, { StylesConfig } from 'react-select';
import { availableIcons } from '../utils/icons'; // adjust path if needed
import { IconType } from 'react-icons';

interface IconPickerSelectProps {
  value: string | null;
  onChange: (value: string | null) => void;
}

interface IconOption {
  label: JSX.Element;
  value: string;
}

// Type-safe custom styles
const customStyles: StylesConfig<IconOption, false> = {
  control: (base) => ({
    ...base,
    borderColor: '#ccc',
    borderRadius: '6px',
    minHeight: '40px',
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

const IconPickerSelect: React.FC<IconPickerSelectProps> = ({ value, onChange }) => {
  const iconOptions: IconOption[] = availableIcons.map((icon) => ({
    label: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {React.createElement(icon.component as React.ComponentType<{ size?: number }>, { size: 20 })}
        <span>{icon.name}</span>
      </div>
    ),
    value: icon.name,
  }));

  const selectedOption = iconOptions.find((option) => option.value === value) || null;

  const handleChange = (selected: IconOption | null) => {
    onChange(selected ? selected.value : null);
  };

  return (
    <Select
      value={selectedOption}
      onChange={handleChange}
      options={iconOptions}
      placeholder="Select icon..."
      isClearable
      classNamePrefix="icon-select"
      styles={customStyles}
    />
  );
};

export default IconPickerSelect;
